export class RevertAllTemplateCustomizationsError extends Error {
  constructor(message: string = 'Failed to revert all inspection template customizations') {
    super(message);
    this.name = 'RevertAllTemplateCustomizationsError';
  }
}
